export default {
  verifications() {
    const url = '/api/users/verifications';

    return $.ajax({
      url,
      type: 'get',
      datatype: 'json',
    });
  },
  sendVerifications(userId) {
    const url = '/api/users/verifications';

    return $.ajax({
      url,
      headers: {'X-CSRF-Token': formToken},
      data: {user_id: userId},
      type: 'post',
      datatype: 'json',
    });
  },
};
